import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchSuperAdminProducts, deleteSuperAdminProduct } from '../../../../../jsx/actions/superAdminProductAction';
import Products from '../../adminModule/AdminDashboard/Products/Products';

// Page « Produits » de la console SuperAdmin : les produits canoniques, tous comptes
// confondus, avec les comptes qui les vendent et leurs prix.
//
// L'écran lui-même vit dans adminModule/AdminDashboard/Products et n'est pas dupliqué ici.
// Il avait d'abord été monté dans la console de configuration, celle de l'application
// d'administration. C'était une impasse : le backend renvoie tout compte de rôle 5 vers la
// console SuperAdmin (controllers/index.js, /adminMainView), et le relais
// /stocks/superadmin/products n'autorise que ce rôle. Un SuperAdmin ne pouvait donc pas
// atteindre l'écran, et un administrateur ordinaire qui l'atteignait recevait un 403.
//
// Comme usersRoles.jsx, cette page se branche elle-même au magasin : la connexion de
// l'application SuperAdmin n'expose que la langue, les pages autorisées et le jeton, jamais
// les actions d'un écran particulier.
function Produits(props) {
    return <Products {...props} />
}

const mapStateToProps = (state) => {
    return {
        SUPERADMIN_PRODUCTS: state.superAdminProducts,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSuperAdminProducts,
        deleteSuperAdminProduct,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Produits)
